import React, { Component } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@mui/material/Box';
import { shadows } from '@mui/system';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import {Footer} from './Footer';
import {TitleBar, SideBar} from './Header';
import {Content} from './Content';

import Button from '@mui/material/Button';



//-----------------------------------------------------------------



class Home extends Component {
  
  render() {

    /*
    const theme = createMuiTheme({
      palette: {
        primary: { main: '#073f8d' }, //#161616
        secondary: { main: '#195CFF' },
      },
    });*/

    const theme = createTheme({
      palette: {
        type: 'dark',
        primary: {
          main: '#00549F',
          dark: '#1a237e',
          light: '#00b0ff',
        },
        secondary: {
          main: '#00b0ff',
        },
        background: {
          default: '#fafafa',
        },
      },
      shape: {
        borderRadius: 28,
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: 28,
            },
          }, 
        }, 
      },
    });

    return (
      <ThemeProvider theme={theme}>

          <CssBaseline />


          <Box
            sx={{ ml: 8,
            }}
          >

            <Content/>

          </Box>

          <Box
            sx={{
              boxShadow: 2
            }}
          >

            <SideBar/>

          </Box>

          


      </ThemeProvider>
    );
  }
}

export default Home;
